import React, { useEffect } from "react";
import "@/App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { SlaVsFdmSection } from "./components/SlaVsFdmSection";
import { WorkflowSection } from "./components/WorkflowSection";
import { WhyFormlabsSection } from "./components/WhyFormlabsSection";
import { PrintersSection } from "./components/PrintersSection";
import { PackagesSection } from "./components/PackagesSection";
import { MaterialsSection } from "./components/MaterialsSection";
import { CaseStudiesSection } from "./components/CaseStudiesSection";
import { IndustriesSection } from "./components/IndustriesSection";
import { AboutSection } from "./components/AboutSection";
import { EducationSection } from "./components/EducationSection";
import { FaqSection } from "./components/FaqSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }, []);

  return (
    <div className="App">
      <Header />
      {/* 1. Hero */}
      <HeroSection />
      {/* 2. SLA vs FDM */}
      <SlaVsFdmSection />
      {/* 3. SLA Workflow */}
      <WorkflowSection />
      {/* 4. Why Formlabs */}
      <WhyFormlabsSection />
      {/* 5. Printers */}
      <PrintersSection />
      {/* 6. Packages */}
      <PackagesSection />
      {/* 7. Materials */}
      <MaterialsSection />
      {/* 8. Case Studies */}
      <CaseStudiesSection />
      {/* 9. Education & Safety */}
      <EducationSection />
      {/* 10. Industries */}
      <IndustriesSection />
      {/* 11. FAQ */}
      <FaqSection />
      {/* 12. About 3DPG */}
      <AboutSection />
      {/* 13. Contact */}
      <ContactSection />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
